import {
  readWorkspaceLocal,
  writeWorkspaceLocal,
  WS_KEY,
} from "../../utils/workspaceStorage";

export function isChatQueueKeyboardHintDismissed() {
  try {
    return readWorkspaceLocal(WS_KEY.CHAT_QUEUE_KEYBOARD_HINT_DISMISSED) === "1";
  } catch {
    return false;
  }
}

export function dismissChatQueueKeyboardHint() {
  try {
    writeWorkspaceLocal(WS_KEY.CHAT_QUEUE_KEYBOARD_HINT_DISMISSED, "1");
  } catch {
    /* ignore */
  }
}
